import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  TargetDomain,
  API_PATH_TARGET_DOMAIN,
} from './targetDomain.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getTargetDomainList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<TargetDomain>> {
  return http.get(`${API_PATH_TARGET_DOMAIN}`);
}

export function getTargetDomain(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<TargetDomain>> {
  return http.get(`${API_PATH_TARGET_DOMAIN}/${id}`);
}

export function deleteTargetDomain(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<TargetDomain>> {
  return http.delete(`${API_PATH_TARGET_DOMAIN}/${id}`, { data: body.auditDetails });
}

export function createTargetDomain(
  deliveryFunctionId: string,
  body: WithAuditDetails<TargetDomain>,
): AxiosPromise<ServerResponse<void>> {
  return http.post(`${API_PATH_TARGET_DOMAIN}`, body);
}

export function updateTargetDomain(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<TargetDomain>,
): AxiosPromise<ServerResponse<void>> {
  return http.put(`${API_PATH_TARGET_DOMAIN}/${id}`, body);
}
